import { ModuleWithProviders, NgModule, inject } from '@angular/core';
import { MODALS_CONFIG, ModalWidth } from '@improver/components/modals';
import { SELECT_CONFIG } from '@improver/components/select';
import { TABLE_ACTION_BUTTON_CONFIG } from '@improver/components/tables';
import { TOGGLE_CONFIG } from '@improver/components/toggle';
import { TranslateService } from '@ngx-translate/core';

// It should not contain any declarations for components

@NgModule()
export class ImproverComponentLibraryModule {
  static forRoot({ modalWithConfig }: { modalWithConfig: any }): ModuleWithProviders<ImproverComponentLibraryModule> {
    return {
      ngModule: ImproverComponentLibraryModule,
      providers: [
        {
          provide: SELECT_CONFIG,
          useFactory: () => {
            const translate = inject(TranslateService);

            return {
              defaultPlaceholder: translate.instant('APP_FORM_SELECT_DEFAULT_OPTION_DEFAULT_LABEL'),
            };
          },
          deps: [TranslateService],
        },
        {
          provide: TABLE_ACTION_BUTTON_CONFIG,
          useValue: {
            defaultLabel: 'APP_ACTION_BUTTON_LABEL',
          },
        },
        {
          provide: TOGGLE_CONFIG,
          useValue: {
            defaultTranslations: {
              labelOff: 'APP_FORM_TOGGLE_SWITCH_OFF_LABEL',
              labelOn: 'APP_FORM_TOGGLE_SWITCH_ON_LABEL',
            },
          },
        },
        {
          provide: MODALS_CONFIG,
          useValue: {
            widths: modalWithConfig,
            defaultWidth: ModalWidth.medium,
          },
        },
      ],
    };
  }
}
